export default "__VITE_ASSET__iREq3wyK__"